import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddNewBanner() {
  const [formData, setFormData] = useState({
    bannerType: '',
    supplierId: '',
    supplierName: '',
    website: '',
    isActive: false,
  });

  const [suppliers, setSuppliers] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    fetch('https://backend-zkgn.onrender.com/api/suppliers')
      .then(res => res.json())
      .then(data => setSuppliers(data))
      .catch(err => console.error('Error fetching suppliers:', err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSupplierChange = (e) => {
    const selectedId = e.target.value;
    const selectedSupplier = suppliers.find(
      (s) => s.supplier_id.toString() === selectedId
    );
    setFormData(prev => ({
      ...prev,
      supplierId: selectedId,
      supplierName: selectedSupplier?.supplier_name || '',
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bannerType || !formData.supplierId || !imageFile) {
      toast.error('Please fill all required fields and upload a banner image.');
      return;
    }

    try {
      const submissionData = new FormData();
      submissionData.append('bannerType', formData.bannerType);
      submissionData.append('supplierId', formData.supplierId);
      submissionData.append('supplierName', formData.supplierName);
      submissionData.append('website', formData.website);
      submissionData.append('isActive', formData.isActive ? '1' : '0');
      submissionData.append('image', imageFile);

      const res = await fetch('http://localhost:3002/api/banners', {
        method: 'POST',
        body: submissionData,
      });

      const result = await res.json();

      if (res.ok) {
        toast.success('Banner added successfully!');
        // Reset form
        setFormData({
          bannerType: '',
          supplierId: '',
          supplierName: '',
          website: '',
          isActive: false,
        });
        setImageFile(null);
        setImagePreview(null);
      } else {
        toast.error(result.message || 'Failed to add banner');
      }

    } catch (err) {
      console.error('Error submitting form:', err);
      toast.error('Error submitting form');
    }
  };

  return (
    <div className="container my-4">
      <ToastContainer autoClose={3000} position="top-right" />
      <h3 className="mb-4">Add New Banner</h3>
      <form onSubmit={handleSubmit} className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Banner Type<span className="text-danger">*</span></label>
          <select
            className="form-select"
            name="bannerType"
            value={formData.bannerType}
            onChange={handleChange}
            required
          >
            <option value="">Select Type</option>
            <option value="Home Page Banner">Home Page Banner</option>
            <option value="Supplier Banner">Supplier Page Banner</option>
            <option value="Side Banner">Side Banner</option>
            <option value="InSide Banner">InSide Banner</option>
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label">Supplier Name<span className="text-danger">*</span></label>
          <select
            className="form-select"
            name="supplierId"
            value={formData.supplierId}
            onChange={handleSupplierChange}
            required
          >
            <option value="">Select Supplier</option>
            {suppliers.map((supplier) => (
              <option key={supplier.supplier_id} value={supplier.supplier_id}>
                {supplier.supplier_name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label">Website</label>
          <input
            type="url"
            className="form-control"
            name="website"
            value={formData.website}
            onChange={handleChange}
            placeholder="https://example.com"
          />
        </div>

        <div className="col-md-6 d-flex align-items-center">
          <div className="form-check mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
              id="isActive"
            />
            <label className="form-check-label" htmlFor="isActive">Is Active</label>
          </div>
        </div>

        <div className="col-md-6">
          <label className="form-label">Upload Banner Image<span className="text-danger">*</span></label>
          <input
            type="file"
            accept="image/*"
            className="form-control"
            onChange={handleImageChange}
            required
          />
        </div>

        {imagePreview && (
          <div className="col-md-6">
            <label className="form-label">Preview:</label>
            <div className="img-preview border rounded p-2">
              <img src={imagePreview} alt="Preview" className="img-fluid" />
            </div>
          </div>
        )}

        <div className="col-12 text-end">
          <button type="submit" className="btn btn-success px-4">Add Banner</button>
        </div>
      </form>
    </div>
  );
}

export default AddNewBanner;
